var codeblock_default = {
  "blockStyleSpacing": "gJg4T",
  "codeBlock": "k7SWC gJg4T",
  "renderedInTable": "QXUb1"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
